import { useTheme } from 'styled-components'

import { HOMEPAGE_GPT_ID } from '@/components-page/homepage/advertisement/homepageAdSlots'
import { StyledGptStickyHP } from '@/components-page/homepage/advertisement/styled'
import { triggerManualAdRefresh } from '@/features/advertisement/utils/triggerManualAdRefresh'
import { useBreakpointChange } from '@/hooks/useBreakpointChange'

export const GptStickyHP = () => {
  const { breakpoints } = useTheme()

  useBreakpointChange([breakpoints.medium], () => {
    triggerManualAdRefresh(HOMEPAGE_GPT_ID.GPT_STICKY)
  })

  return (
    <StyledGptStickyHP id={HOMEPAGE_GPT_ID.GPT_STICKY} data-testid={HOMEPAGE_GPT_ID.GPT_STICKY} />
  )
}
